import { UsersService } from '$services/users/users.service'
import { UserDisplay } from '$types'
import { Component, EventEmitter, Output, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { Observable } from 'rxjs'
import { debounceTime, distinctUntilChanged, switchMap, tap, finalize, filter } from 'rxjs/operators'

@Component({
  selector: 'app-user-select',
  templateUrl: './user-select.component.html',
  styleUrls: ['./user-select.component.css']
})
export class UserSelectComponent implements OnInit {
  @Output() userSelected = new EventEmitter<UserDisplay>()

  userSearchContol = new FormControl()
  filteredOptions: UserDisplay[] = []
  loading: boolean = false
  clickedOnOption: boolean = false
  selectedUser?: string

  constructor(private userService: UsersService) {
  }
  ngOnInit() {
    this.userSearchContol.valueChanges.pipe(
      debounceTime(400),
      filter(() => {
        if(this.clickedOnOption){
          this.clickedOnOption = false
          return false
        }
        return true
      }),
      distinctUntilChanged(),
      tap(() => {
        this.filteredOptions = []
        this.loading = true
      }),
      switchMap(val => this
        .filter(val || '')
        .pipe(
          finalize(() => {
            this.loading = false
          }),
        ))
    ).subscribe(data => this.processUser(data))
  }

  clearSelection() {
    this.selectedUser = undefined
    this.filteredOptions = []
    this.loading = false
  }
  onUserSelected(user: UserDisplay) {
    console.log(user)
    this.selectedUser = user.displayNameString
    this.clickedOnOption = true
    this.userSelected.emit(user)
  }


  private filter(val: string): Observable<UserDisplay[]> {
    // call the service which makes the http-request
    return this.userService.search(val)
  }

  private processUser(users: UserDisplay[]) {
    this.filteredOptions = users
  }
}
